import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../../Table/DetailsTable';
import FeatureSummary from '../../../../Util/FeatureSummary';

const RedirectsTable = ({
    redirects,
    setSelectedRedirect,
    loading,
    editOnClick,
    createOnClick,
    previewOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} previewOnClick={previewOnClick} id={item.redirectId} item={item} deleteOnClick={deleteOnClick} />
            ),
        },
        {
            name: 'RedirectId',
            fieldName: 'redirectId',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Old Url',
            fieldName: 'oldUrl',
            minWidth: 400,
            maxWidth: 450,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
            onRender: (item) =>
                item.oldUrl ? (
                    <a href={`http://www.igrad.com${item.oldUrl}`} target="_blank" rel="noopener noreferrer">
                        {item.oldUrl}
                    </a>
            ) : null,
        },
        {
            name: 'New Url',
            fieldName: 'newUrl',
            minWidth: 400,
            maxWidth: 450,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
            onRender: (item) =>
                item.newUrl ? (
                    <a href={`http://www.igrad.com${item.newUrl}`} target="_blank" rel="noopener noreferrer">
                        {item.newUrl}
                    </a>
            ) : null,
        },
        {
            name: 'On Old Site',
            fieldName: 'onOldSite',
            minWidth: 200,
            maxWidth: 250,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
    ];

    const items = redirects ?? [];

    const selectionHook = (items) => {
        setSelectedRedirect(items && items[0] && items[0].redirectId);
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={'name'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Redirect"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Redirects"
		        summary="This table displays all URL redirects, including the old and new URLs and whether the redirect is on the old site. You can add, edit, or delete redirects. The Redirects feature allows admins to manage URL changes and ensure users are directed to the correct content."
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, item, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id, item?.oldUrl || item?.newUrl || item?.name || item?.slug || ""),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default RedirectsTable;
